module.exports = __webpack_public_path__ + "img/avatar-s-17.4a7d2722.jpg";